import apiClient from "./client";
import type {
  InstallationStatsAll,
  InstallationProductCount,
  InstallationRecord,
  InstallationQueryParams,
  ApiResponse,
  ListResponse,
} from "@/types";

const PUBLIC_BASE = "/public/installation-stats";
const ADMIN_BASE = "/installations";

// getInstallationStats 获取全部安装统计与记录列表
export async function getInstallationStats(): Promise<
  ApiResponse<InstallationStatsAll>
> {
  const { data } = await apiClient.get(PUBLIC_BASE);
  return data;
}

// getInstallationCount 查询指定产品的安装数量
export async function getInstallationCount(
  productKey: string,
): Promise<ApiResponse<InstallationProductCount>> {
  const { data } = await apiClient.get(PUBLIC_BASE, {
    params: { product_key: productKey },
  });
  return data;
}

// listInstallations 查询安装记录列表（分页 + 条件查询）
export async function listInstallations(
  params?: InstallationQueryParams,
): Promise<ApiResponse<ListResponse<InstallationRecord>>> {
  const { data } = await apiClient.get(ADMIN_BASE, { params });
  return data;
}
